export default __webpack_public_path__ + "static/media/cancel.5409a8d9.png";